import { NextSeo } from 'next-seo';
import TrademarkMonitoringPage from 'components/composed/pages/TrademarkMonitoringPage';

export default function TrademarkMonitoring() {
  return (
    <>
      <NextSeo title="Trademark Monitoring" />
      <TrademarkMonitoringPage />
    </>
  );
}
